/** Tiny inline icon set. We avoid pulling lucide-react to keep the bundle slim. */
import type { SVGProps } from 'react';

const base = (props: SVGProps<SVGSVGElement>) => ({
  width: 16,
  height: 16,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  ...props,
});

export const IconDashboard = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <rect x="3" y="3" width="6" height="8" rx="1.5" />
    <rect x="11" y="3" width="6" height="4" rx="1.5" />
    <rect x="11" y="9" width="6" height="8" rx="1.5" />
    <rect x="3" y="13" width="6" height="4" rx="1.5" />
  </svg>
);

export const IconBuilding = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M3 17V7l7-3 7 3v10M3 17h14M7 17v-4h6v4M7 9h.01M10 9h.01M13 9h.01" />
  </svg>
);

export const IconUser = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <circle cx="10" cy="7" r="3" />
    <path d="M3 17c0-3.3 3.1-6 7-6s7 2.7 7 6" />
  </svg>
);

export const IconNews = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M4 5h12v10a2 2 0 0 1-2 2H4V5z" />
    <path d="M16 7h2v8a2 2 0 0 1-2 2" />
    <path d="M7 9h6M7 12h6M7 15h4" />
  </svg>
);

export const IconChart = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M3 17h14M5 13l3-4 3 3 4-6" />
  </svg>
);

export const IconSearch = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <circle cx="9" cy="9" r="5" />
    <path d="m13 13 3.5 3.5" />
  </svg>
);

export const IconBell = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M5 9a5 5 0 0 1 10 0v3l1.5 2.5h-13L5 12V9z" />
    <path d="M8 16a2 2 0 0 0 4 0" />
  </svg>
);

export const IconUpload = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M10 4v10M5 9l5-5 5 5M3 17h14" />
  </svg>
);

export const IconPlus = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M10 4v12M4 10h12" />
  </svg>
);

export const IconClose = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M5 5l10 10M15 5L5 15" />
  </svg>
);

export const IconCheck = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base({ strokeWidth: 1.7, ...p })}>
    <path d="M5 10l3 3 7-7" />
  </svg>
);

export const IconChevronRight = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}><path d="M8 5l4 5-4 5" /></svg>
);

export const IconChevronDown = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}><path d="M5 8l5 5 5-5" /></svg>
);

export const IconDots = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <circle cx="4" cy="10" r="1.5" />
    <circle cx="10" cy="10" r="1.5" />
    <circle cx="16" cy="10" r="1.5" />
  </svg>
);

export const IconLogout = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M11 4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6M14 8l3 2-3 2M9 10h8" />
  </svg>
);

export const IconRefresh = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M4 10a6 6 0 0 1 11-3M16 10a6 6 0 0 1-11 3M15 4v3h-3M5 16v-3h3" />
  </svg>
);

export const IconCog = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <circle cx="10" cy="10" r="2.5" />
    <path d="M10 2.5v1.5M10 16v1.5M2.5 10h1.5M16 10h1.5M4.6 4.6l1.1 1.1M14.3 14.3l1.1 1.1M4.6 15.4l1.1-1.1M14.3 5.7l1.1-1.1" />
  </svg>
);

export const IconBookmark = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M5 3h10v15l-5-3-5 3V3z" />
  </svg>
);

/* ---------- Admin refonte 2026-05-28, nouveaux icons pour les 9 stubs ---------- */

export const IconInbox = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M3 13l2-8h10l2 8M3 13v4h14v-4M3 13h4l1 2h4l1-2h4" />
  </svg>
);

export const IconGift = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <rect x="3" y="8" width="14" height="9" rx="1.5" />
    <path d="M3 11h14M10 8v9M7 8s-2-3 0-4 3 4 3 4M13 8s2-3 0-4-3 4-3 4" />
  </svg>
);

export const IconLayers = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M10 3l7 4-7 4-7-4 7-4z" />
    <path d="M3 11l7 4 7-4M3 15l7 4 7-4" />
  </svg>
);

export const IconEye = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M2 10s3-6 8-6 8 6 8 6-3 6-8 6-8-6-8-6z" />
    <circle cx="10" cy="10" r="2.5" />
  </svg>
);

export const IconFile = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M5 2h7l4 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
    <path d="M12 2v4h4M7 10h6M7 13h6M7 16h4" />
  </svg>
);

export const IconUsers = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <circle cx="7" cy="7" r="2.5" />
    <circle cx="14" cy="8" r="2" />
    <path d="M2 16c0-2.7 2.3-5 5-5s5 2.3 5 5M11 16c0-2 1.8-4 4-4s4 2 4 4" />
  </svg>
);

export const IconMail = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <rect x="2" y="4" width="16" height="12" rx="1.5" />
    <path d="M2 6l8 6 8-6" />
  </svg>
);

export const IconAtom = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <circle cx="10" cy="10" r="1.5" />
    <ellipse cx="10" cy="10" rx="8" ry="3" />
    <ellipse cx="10" cy="10" rx="8" ry="3" transform="rotate(60 10 10)" />
    <ellipse cx="10" cy="10" rx="8" ry="3" transform="rotate(-60 10 10)" />
  </svg>
);

export const IconActivity = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}>
    <path d="M2 10h4l2-6 4 12 2-6h4" />
  </svg>
);
